

const Comidix = () => {
    return (
        <section id="portfolio-details" className="portfolio-details" style={{ marginTop: '5rem' }}>
            <div className="container">
                <div className="row gy-4">
                    <div className="col-lg-8">
                        <div className="portfolio-description">
                            <h2>Comidix AI</h2>
                            <p>
                                ¿Estás cansado de tener que tirar comida porque olvidas qué hay en tu nevera? ¿No tienes una nevera inteligente que te avise sobre los productos que tienes en casa o te alerte cuando tus yogures están a punto de caducar? Comidix AI es la solución que estás buscando.
                            </p>
                            <p>
                                Comidix AI es una innovadora solución basada en inteligencia artificial que tiene como objetivo registrar tus compras para que en todo momento sepas qué tienes en casa, qué necesitas y qué productos están a punto de caducar. Además, Comidix AI aprovecha el poder de la inteligencia artificial para generar recetas de cocina personalizadas utilizando los productos disponibles en tu casa, imitando los estilos de grandes chefs.
                            </p>
                            <p>
                                Pero eso no es todo. Comidix AI va más allá al ofrecerte la posibilidad de gestionar tu despensa, prepararte recetas personalizadas, crear menús y dietas con los alimentos disponibles e incluso sugerirte platos con productos que actualmente no tienes en casa. Además, te proporciona una lista de la compra inteligente que puedes recibir en tu móvil, imagina lo facil que seria sorprender a tus invitados, simplemente le tendrías que pedir a ComidixAI  que te preparase un menú de 3 platos al estilo del chef que más te guste y totalmente adaptado a las alergias alimentarias te tus invitados
                            </p>
                            <p>
                                Actualmente, el proyecto se encuentra en fase de desarrollo, ¡pero pronto estará disponible para revolucionar la forma en que gestionas tu despensa y cocinas en casa!
                            </p>

                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="portfolio-info">
                            <h3>Información del Proyecto</h3>
                            <ul>
                                <li><strong>Categoria</strong>: AI, App Mobile</li>
                                <li><strong>Fecha de inicio</strong>: 2 de Diciembre, 2023</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Comidix;
